export default "__VITE_ASSET__QfFdeTi3__"